module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLoading) ? _c('div', [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "color": "#6666ff",
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1) : _c('div', {
    staticClass: "is-fullhd"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n        Welcome to the Member edit page. From here you can add, modify or delete Team Member information. Simply click any of the highlighted fields. If you have any questions, "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.contactModal()
      }
    }
  }, [_vm._v("send us a message")]), _vm._v(" and we’ll be right with you\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "section",
    staticStyle: {
      "padding": "1rem 1rem 1rem 1rem",
      "border": "1px solid whitesmoke",
      "border-radius": "10px"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Invite member by entering email address below")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.members[0].email),
      expression: "members[0].email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter email",
      "disabled": _vm.displayMembers.length > 10
    },
    domProps: {
      "value": (_vm.members[0].email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.members[0], "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control has-text-right"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.inviteModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Email Preview\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(" ")]), _vm._v(" "), (_vm.members[0].email !== '') ? _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addUser()
      }
    }
  }, [_vm._v("Invite Member")])]) : _vm._e(), _vm._v(" "), (_vm.members[0].email === '') ? _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Invite Member")])]) : _vm._e()])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayMembers.length > 10),
      expression: "displayMembers.length > 10"
    }]
  }, [_vm._v("\n        You can add a maximum of 10 team members in the free risk assessment. "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.contactModal()
      }
    }
  }, [_vm._v("Contact us")]), _vm._v(" to upgrade.\n      ")])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.displayMembers.length > 0) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "table-responsive invitedMemberTable"
  }, [_c('small', {
    staticClass: "has-text-grey-light is-pulled-right"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.remindModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Reminder Preview\n          ")])]), _vm._v(" "), _c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.displayMembers), function(item, index) {
    return _c('tr', {
      staticClass: "list-group-item"
    }, [_c('td', [_vm._v("\n                " + _vm._s(item.member) + "\n              ")]), _vm._v(" "), (item.status === 1) ? _c('td', [_vm._m(2, true), _vm._v("\n                Invited (not joined)\n              ")]) : _vm._e(), _vm._v(" "), (item.status === 2) ? _c('td', [_vm._m(3, true), _vm._v("\n                Assessment pending\n              ")]) : _vm._e(), _vm._v(" "), (item.status === 3) ? _c('td', [_vm._m(4, true), _vm._v("\n                Assessment Submitted\n              ")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "is-icon"
    }, [(item.role === 'TL' || item.status === 3) ? _c('button', {
      staticClass: "button is-primary is-small",
      attrs: {
        "disabled": ""
      }
    }, [_c('i', {
      staticClass: "fa fa-bell"
    }, [_vm._v(" Remind")])]) : _vm._e(), _vm._v(" "), (item.role !== 'TL' && item.status !== 3) ? _c('button', {
      staticClass: "button is-primary is-small"
    }, [_c('i', {
      staticClass: "fa fa-bell",
      on: {
        "click": function($event) {
          return _vm.remind(item)
        }
      }
    }, [_vm._v(" Remind")])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "is-icon",
      staticStyle: {
        "width": "30px"
      }
    }, [(item.role !== 'TL') ? _c('button', {
      staticClass: "button is-danger is-small"
    }, [_c('i', {
      staticClass: "fa fa-trash",
      on: {
        "click": function($event) {
          return _vm.deleteUser(item)
        }
      }
    }, [_vm._v(" Remove")])]) : _vm._e(), _vm._v(" "), (item.role === 'TL') ? _c('button', {
      staticClass: "button is-danger is-small",
      attrs: {
        "disabled": ""
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }, [_vm._v(" Remove")])]) : _vm._e()])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal contactModal",
    class: {
      isActive: _vm.contactModalOpen
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n              Contact Us\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": function($event) {
        return _vm.closeContactModal()
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Your Message")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "textarea",
    attrs: {
      "rows": "3",
      "placeholder": "Your Message"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.contactSubmit()
      }
    }
  }, [_vm._v("Send")])])]) : _vm._e(), _vm._v(" "), (!_vm.message) ? _c('div', {
    staticClass: "field"
  }, [_vm._m(5)]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal inviteModal",
    class: {
      isActive: _vm.inviteModalOpen
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box is-paddingless"
  }, [_c('div', {
    staticClass: "preview-header has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": "https://www.changevu.com/img/logo2x.png",
      "href": "https://www.changevu.com/",
      "alt": "ChangeVU",
      "width": "150px"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": function($event) {
        return _vm.closeInviteModal()
      }
    }
  })]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "preview-body has-text-white"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "has-text-white"
  }, [_vm._v("\n                You've been invited to join ChangeVU's change risk assessment.\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(this.user.firstName + ' ' + this.user.lastName) + " invited you to run a team change risk assessment.\n              ")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', [_vm._v("\n                You have until " + _vm._s(this.initiative.deadline) + " to complete the assessment.\n                ")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Team Name:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.initiative.teamName))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Team Leader:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.user.firstName) + " " + _vm._s(this.user.lastName))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Initiative name:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.initiative.name))])])])])])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal remindModal",
    class: {
      isActive: _vm.remindModalOpen
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box is-paddingless"
  }, [_c('div', {
    staticClass: "preview-header has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": "https://www.changevu.com/img/logo2x.png",
      "href": "https://www.changevu.com/",
      "alt": "ChangeVU",
      "width": "150px"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": function($event) {
        return _vm.closeRemindModal()
      }
    }
  })]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "preview-body has-text-white"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "has-text-white"
  }, [_vm._v("\n                Reminder: Change Risk Assessment\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                Hi there,\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                 You've been invited by " + _vm._s(this.initiative.teamLead) + " to a free change risk assessment."), _c('br'), _vm._v("\n                 The deadline for completing the assessment is " + _vm._s(this.initiative.deadline) + "\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                Click the button below to login and run your assessment.\n              ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0rem !important"
    }
  }, [_vm._v("\n                Your team details:\n              ")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Team Name:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.initiative.teamName))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Team Leader:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.initiative.teamLead))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "125px"
    }
  }, [_vm._v("Initiative name:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.initiative.name))])])])])])]), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n        Manage Member(s)\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Member")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "250px"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon",
    staticStyle: {
      "color": "#b5b5b5"
    }
  }, [_c('i', {
    staticClass: "fa fa-square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon",
    staticStyle: {
      "color": "#fce473"
    }
  }, [_c('i', {
    staticClass: "fa fa-square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon has-text-primary"
  }, [_c('i', {
    staticClass: "fa fa-square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Send")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-banner has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": "https://www.changevu.com/img/banners/changeLeaders.jpg",
      "href": "https://www.changevu.com/",
      "alt": "ChangeVU"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                Click the link below to accept the invitation."), _c('br'), _vm._v("\n                Validate your email and password to access the change risk assessment.\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-body-button"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary has-text-black"
  }, [_vm._v("Accept Invitation")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-body has-text-white"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n                Welcome to ChangeVU!"), _c('br'), _c('br'), _vm._v("\n                Thanks,"), _c('br'), _vm._v("ChangeVU Team\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-footer"
  }, [_c('div', {
    staticClass: "footer-img"
  }, [_c('img', {
    attrs: {
      "src": "https://x5n8g.mjt.lu/tplimg/x5n8g/b/xzs81/oi9i.jpeg",
      "alt": "Connect to better change navigation"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "has-text-centered"
  }, [_c('a', {
    staticStyle: {
      "color": "#9B9B9B"
    },
    attrs: {
      "href": "#/teamInfo"
    }
  }, [_vm._v("Unsubscribe")]), _vm._v(" to stop receiving these emails from us."), _c('br'), _vm._v("\n              Straticom Technologies R&D, 931 Lake Drive North, Georgina, Ontario, L4P3E9"), _c('br'), _vm._v("\n              © 2020 Straticom Technologies R&D, all rights reserved.\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-banner has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": "https://www.changevu.com/img/banners/blogs.jpg",
      "href": "https://www.changevu.com/",
      "alt": "ChangeVU"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-body-button"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary has-text-black"
  }, [_vm._v("Run Assessment")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-body has-text-white"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n                If you have any questions "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/teamInfo"
    }
  }, [_vm._v("Click here.")]), _c('br'), _c('br'), _vm._v("\n                Thanks,"), _c('br'), _vm._v("ChangeVU Team\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-footer"
  }, [_c('div', {
    staticClass: "footer-img"
  }, [_c('img', {
    attrs: {
      "src": "https://x5n8g.mjt.lu/tplimg/x5n8g/b/xzs81/oi9i.jpeg",
      "alt": "Connect to better change navigation"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "has-text-centered"
  }, [_c('a', {
    staticStyle: {
      "color": "#9B9B9B"
    },
    attrs: {
      "href": "#/teamInfo"
    }
  }, [_vm._v("Unsubscribe")]), _vm._v(" to stop receiving these emails from us."), _c('br'), _vm._v("\n              Straticom Technologies R&D, 931 Lake Drive North, Georgina, Ontario, L4P3E9"), _c('br'), _vm._v("\n              © 2020 Straticom Technologies R&D, all rights reserved.\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57a82ec8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/teamMember/teamMembers.vue
// module id = 373
// module chunks = 5